export enum VehicleImageType {
  DEFAULT = 'DEFAULT',
  PROFILE = 'PROFILE',
}
